import { Strings } from "@app/constants";

export const featureData = [
  {
    img: "/assets/images/wallet.png",
    title: Strings.home.bestPriceGuarantee,
    desc: Strings.home.finedALower,
  },
  {
    img: "/assets/images/user-tick.png",
    title: Strings.home.premiumCars,
    desc: Strings.home.getPremiumCards,
  },
  {
    img: "/assets/images/calender.png",
    title: Strings.home.hourCarDelivery,
    desc: Strings.home.bookYourCar,
  },
  {
    img: "/assets/images/messages-2.png",
    title: Strings.home.technicalSupport,
    desc: Strings.home.haveAQuestion,
  },
];
